"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSFooter = void 0;
const ui_1 = require("@app/component/ui");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const useMe_1 = require("@app/util/hooks/useMe");
const use_modal_1 = require("@app/util/modal/use-modal");
const react_1 = __importDefault(require("react"));
const calendar_settings_context_1 = require("../calendar-settings-context");
const update_user_options_1 = require("../util/update-user-options");
const CSFooter = () => {
    const dispatch = (0, store_1.useRootDispatch)();
    const me = (0, useMe_1.useMe)();
    const { closeModal } = (0, use_modal_1.useModal)();
    const { handleSubmit, options, isDirty, reset, loading, setLoading } = (0, calendar_settings_context_1.useCalendarSettingsContext)();
    return (react_1.default.createElement("div", { style: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        } },
        react_1.default.createElement("div", { style: { cursor: 'pointer' }, onClick: () => util_1.miscUtil.copyToClipBoard(me.id) },
            "DS ID: ",
            me.id),
        react_1.default.createElement("div", { style: { display: 'flex' } },
            react_1.default.createElement(ui_1.Button, { onClick: () => closeModal() }, (0, util_1.t)('CLOSE')),
            react_1.default.createElement(ui_1.Button, { style: 'CONTAINED', disabled: !isDirty || loading, onClick: handleSubmit(async (data) => {
                    setLoading(true);
                    await dispatch((0, update_user_options_1.updateUserOptions)({ form: data, options }));
                    reset(data);
                    setTimeout(() => setLoading(false), 100);
                }) }, (0, util_1.t)('SETUP')))));
};
exports.CSFooter = CSFooter;
